export var SortOrders;
(function (SortOrders) {
    SortOrders["Custom"] = "custom";
    SortOrders["Relevance"] = "relevance";
    SortOrders["Date"] = "date";
    SortOrders["Name"] = "name";
})(SortOrders || (SortOrders = {}));
//# sourceMappingURL=sort-orders.js.map